import React from "react";

import WorklogMissingForm from "./WorklogMissingForm";
import FormDialog from "../Dialog/FormDialog";
import { useMissingItemState } from "./hooks/useMissingItemState";

function MissingItem({ worklog, daily_worklog_hours }) {
  const { dayName, dialog, handleClose, handleOpen, label, missingHours } =
    useMissingItemState(worklog, daily_worklog_hours);

  return (
    <>
      <div className="d-flex justify-content-space-between ">
        <p className="date-hour">{` ${label}`}</p>
        <a className="cursor-pointer " onClick={handleOpen}>
          Didn't work
        </a>
      </div>
      {dialog && (
        <FormDialog
          open={dialog}
          title={"Worklog Missing"}
          handleClose={handleClose}
          fullWidth={true}>
          <WorklogMissingForm
            date={worklog.date}
            time={missingHours}
            handleClose={handleClose}
            dayName={dayName}
          />
        </FormDialog>
      )}
    </>
  );
}

export default React.memo(MissingItem);
